import { render, staticRenderFns } from "./MarketSaleCard.vue?vue&type=template&id=1a95902e&scoped=true&lang=pug"
import script from "./MarketSaleCard.vue?vue&type=script&lang=js"
export * from "./MarketSaleCard.vue?vue&type=script&lang=js"
import style0 from "./MarketSaleCard.vue?vue&type=style&index=0&id=1a95902e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95902e",
  null
  
)

export default component.exports